import { render } from "./Container.vue?vue&type=template&id=5179da12&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"

import "./Container.vue?vue&type=style&index=0&id=5179da12&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5179da12"]])

export default __exports__